import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { addCategory, deleteCategory, getCategory, updateCategory } from 'src/redux/categories'
import {
  CButton,
  CButtonGroup,
  CCard,
  CCardBody,
  CCol,
  CContainer,
  CForm,
  CFormInput,
  CFormText,
  CImage,
  CInputGroup,
  CRow,
  CTable,
  CTableBody,
  CTableDataCell,
  CTableHead,
  CTableHeaderCell,
  CTableRow,
} from '@coreui/react'
import CIcon from '@coreui/icons-react'
import { cilPencil, cilTrash } from '@coreui/icons'
import { toast } from 'react-toastify'
import swal from 'sweetalert'
import { Link } from 'react-router-dom'
import { openLink } from 'src/utils/function'

const Categories = () => {
  const [formData, setFormData] = useState({
    name: '',
    icon: '',
    image: '',
  })
  const [image, setImage] = useState(null)
  const [icon, setIcon] = useState(null)

  const handleImageChange = (e) => {
    const file = e.target.files[0]
    setImage(URL.createObjectURL(file))
    setFormData({ ...formData, image: file })
  }

  const handleIconChange = (e) => {
    const file = e.target.files[0]
    setIcon(URL.createObjectURL(file))
    setFormData({ ...formData, icon: file })
  }

  const dispatch = useDispatch()

  const { categories } = useSelector((state) => state.categories)

  useEffect(() => {
    dispatch(getCategory())
  }, [dispatch])

  const handleSubmit = async () => {
    if (!formData.name) {
      toast('Name required!', { type: 'info' })
    } else if (!formData.icon) {
      toast('Icon required!', { type: 'info' })
    } else if (!formData.image) {
      toast('Image required!', { type: 'info' })
    } else {
      const body = {
        name: formData.name,
        icon: formData.icon,
        image: formData.image,
      }
      const formDataToSend = new FormData()
      Object.keys(body).forEach((key) => {
        formDataToSend.append(key, body[key])
      })
      try {
        await dispatch(addCategory(formDataToSend))
        setFormData({
          name: '',
          icon: '',
          image: '',
        })
        setImage(null)
        setIcon(null)
      } catch (error) {
        toast(error.message, { type: 'error' })
      }
    }
  }

  async function handleDelete(id) {
    await swal({
      title: 'Are you sure? ',
      text: 'You want to delete this Category!',
      icon: 'warning',
      buttons: ['No', 'Yes'],
      dangerMode: true,
    }).then(async (willDelete) => {
      if (willDelete) {
        await dispatch(deleteCategory(id))
      } else {
        console.log(willDelete)
      }
    })
  }

  async function handleUpdate() {
    const body = {
      name: formData.name,
      icon: formData.icon,
      image: formData.image,
    }
    const formDataToSend = new FormData()
    Object.keys(body).forEach((key) => {
      formDataToSend.append(key, body[key])
    })
    await dispatch(updateCategory(formData?.id, formDataToSend))
    setFormData({ name: '', icon: '', image: '' })
    setImage(null)
    setIcon(null)
  }

  return (
    <div className="bg-light d-flex flex-row align-items-center">
      <CContainer>
        <CRow className="justify-content-center">
          <CCol md={9} lg={7} xl={8}>
            <CTable align="middle" className="mb-0 border" hover responsive>
              <CTableHead color="light">
                <CTableRow>
                  <CTableHeaderCell className="text-center">Icon</CTableHeaderCell>
                  <CTableHeaderCell>Name</CTableHeaderCell>
                  <CTableHeaderCell className="text-center">Image</CTableHeaderCell>
                  <CTableHeaderCell className="text-center">Created At</CTableHeaderCell>
                  <CTableHeaderCell className="text-center">Updated At</CTableHeaderCell>
                  <CTableHeaderCell className="text-center">Action</CTableHeaderCell>
                </CTableRow>
              </CTableHead>
              <CTableBody>
                {categories?.map((item, index) => (
                  <CTableRow key={index}>
                    <CTableDataCell className="text-center">
                      <CImage src={item.icon} width={40} height={40} />
                    </CTableDataCell>
                    <CTableDataCell>
                      <small className="text-medium-emphasis">{item.name}</small>
                    </CTableDataCell>
                    <CTableDataCell className="text-center">
                      <Link onClick={() => openLink(item.image)}>
                        <CImage src={item.image} width={80} height={50} className="rounded" />
                      </Link>
                    </CTableDataCell>
                    <CTableDataCell className="text-center">
                      <small className="text-medium-emphasis">
                        {new Date(item.createdAt).toLocaleDateString()}
                      </small>
                    </CTableDataCell>
                    <CTableDataCell className="text-center">
                      <small className="text-medium-emphasis">
                        {new Date(item.updatedAt).toLocaleDateString()}
                      </small>
                    </CTableDataCell>
                    <CTableDataCell className="text-center">
                      <CButtonGroup>
                        <CButton color="danger" size="sm" onClick={() => handleDelete(item.id)}>
                          <CIcon icon={cilTrash} className="text-white" />
                        </CButton>
                        <CButton color="warning" size="sm" onClick={() => setFormData(item)}>
                          <CIcon icon={cilPencil} className="text-dark" />
                        </CButton>
                      </CButtonGroup>
                    </CTableDataCell>
                  </CTableRow>
                ))}
              </CTableBody>
            </CTable>
          </CCol>
          <CCol md={9} lg={7} xl={4}>
            <CCard className="mx-4">
              <CCardBody className="p-4">
                <CForm>
                  <h5 className="text-medium-emphasis mb-3">
                    {formData?.id ? 'Update' : 'Add New'} Category
                  </h5>
                  <CInputGroup className="mb-3">
                    <CFormInput
                      placeholder="Name"
                      value={formData.name || ''}
                      onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                    />
                  </CInputGroup>

                  <div className="mb-3">
                    <CFormText>Select Icon</CFormText>
                    <CFormInput type="file" size="sm" id="pickIcon" onChange={handleIconChange} />
                  </div>
                  {icon && (
                    <CImage
                      src={icon && icon}
                      style={{
                        width: '50%',
                        height: '50%',
                        justifyContent: 'center',
                      }}
                    />
                  )}

                  <div className="mb-3">
                    <CFormText>Select Image</CFormText>
                    <CFormInput type="file" size="sm" id="pickImage" onChange={handleImageChange} />
                  </div>
                  {image && (
                    <CImage
                      src={image && image}
                      style={{
                        width: '100%',
                        height: 150,
                        justifyContent: 'center',
                      }}
                    />
                  )}

                  <div className="d-grid mt-3">
                    <CButton color="success" onClick={formData?.id ? handleUpdate : handleSubmit}>
                      {formData?.id ? 'Update' : 'Submit'}
                    </CButton>
                  </div>
                </CForm>
              </CCardBody>
            </CCard>
          </CCol>
        </CRow>
      </CContainer>
    </div>
  )
}

export default Categories
